import { gql } from '@apollo/client';
import { DetailsFragment } from './fragments/details';
import { EnrichmentsFragment } from './fragments/enrichments';
import { WorkflowStateFragment } from './fragments/workflow_state';

export const GET_CASE = gql`
  query GetCase($input: String!) {
    getCase(id: $input) {
      id
      role
      description
      report_path
      workflow_state {
        ...WorkflowState
      }
      enrichments {
        ...Enrichments
      }
      details {
        ...Details
      }
      widgets {
        id
        data
      }
    }
  }
  ${WorkflowStateFragment}
  ${EnrichmentsFragment}
  ${DetailsFragment}
`;
